/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Add_Member_EmailInputs */

const th_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อีเมล`)
};

const en_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address`)
};

const ja_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレス`)
};

const zh_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮箱`)
};

const es_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirección de correo`)
};

const pt_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endereço de e-mail`)
};

const id_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat email`)
};

const fr_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse e-mail`)
};

const tl_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address`)
};

const vi_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ email`)
};

const ko_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 주소`)
};

const de_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse`)
};

const ru_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адрес электронной почты`)
};

const tr_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta adresi`)
};

const it_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indirizzo email`)
};

const pl_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adres e-mail`)
};

const uk_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адреса електронної пошти`)
};

const hi_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल पता`)
};

const ar_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البريد الإلكتروني`)
};

const ms_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat e-mel`)
};

const bn_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইমেল ঠিকানা`)
};

const zh_tw2_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子郵件`)
};

const zh_hk2_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子郵件`)
};

const ur_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ای میل پتہ`)
};

const fa_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشانی ایمیل`)
};

const sw_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwani ya barua pepe`)
};

const nl_org_add_member_email = /** @type {(inputs: Org_Add_Member_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mailadres`)
};

/**
* | output |
* | --- |
* | "Email address" |
*
* @param {Org_Add_Member_EmailInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_add_member_email = /** @type {((inputs?: Org_Add_Member_EmailInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Add_Member_EmailInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_add_member_email(inputs)
	if (locale === "ja") return ja_org_add_member_email(inputs)
	if (locale === "zh") return zh_org_add_member_email(inputs)
	if (locale === "es") return es_org_add_member_email(inputs)
	if (locale === "pt") return pt_org_add_member_email(inputs)
	if (locale === "id") return id_org_add_member_email(inputs)
	if (locale === "fr") return fr_org_add_member_email(inputs)
	if (locale === "tl") return tl_org_add_member_email(inputs)
	if (locale === "vi") return vi_org_add_member_email(inputs)
	if (locale === "ko") return ko_org_add_member_email(inputs)
	if (locale === "de") return de_org_add_member_email(inputs)
	if (locale === "ru") return ru_org_add_member_email(inputs)
	if (locale === "tr") return tr_org_add_member_email(inputs)
	if (locale === "it") return it_org_add_member_email(inputs)
	if (locale === "pl") return pl_org_add_member_email(inputs)
	if (locale === "uk") return uk_org_add_member_email(inputs)
	if (locale === "hi") return hi_org_add_member_email(inputs)
	if (locale === "ar") return ar_org_add_member_email(inputs)
	if (locale === "ms") return ms_org_add_member_email(inputs)
	if (locale === "bn") return bn_org_add_member_email(inputs)
	if (locale === "zh-TW") return zh_tw2_org_add_member_email(inputs)
	if (locale === "zh-HK") return zh_hk2_org_add_member_email(inputs)
	if (locale === "ur") return ur_org_add_member_email(inputs)
	if (locale === "fa") return fa_org_add_member_email(inputs)
	if (locale === "sw") return sw_org_add_member_email(inputs)
	if (locale === "nl") return nl_org_add_member_email(inputs)
	return en_org_add_member_email(inputs)
});